<template>
    <div class="c-block-wrapper" :class="height === 'stretch' ? 'u-flex-set' : ''">
        <div :class="`u-fullwidth c-block ${size ? `c-block--${size}` : ''} ${type ? `c-block--${type}` : ''}  ${color ? `c-block--${color}` : ''} ${ customClass ? customClass : ''}`">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['custom-class', 'color', 'size', 'height', 'type']
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

    .c-block {
        padding: em($global-spacing-unit) em($global-spacing-unit + 7px);
    }

    .c-block--mini {
        padding: em(0px);
    }

    .c-block--tiny {
        padding: em($global-spacing-unit-tiny);
    }

    .c-block--small {
        padding: em($global-spacing-unit-small);
    }

    .c-block--neutral {
        background-color: palette(color-neutral, x-light);
    }

    .c-block--green {
        background-color: palette(color-success);
        color: white;
    }

    .c-block--base {
        background-color: $color-base;
        color: white;
    }

    .c-block--white {
        background-color: white;
        color: $color-base;
    }

    .c-block--icon-block{
        padding: em($global-spacing-unit) em($global-spacing-unit-small);
        text-align: center;
        word-wrap: break-word;
        hyphens: auto;
    }
    

</style>


// WEBPACK FOOTER //
// src/components/blocks/Block.vue